import { SubjectivitySearchRequestQuery } from '@lio/api-types';

export const subjectivityQueryKeys = {
  search: (quoteId?: string) => ['subjectivities', quoteId] as const,
  searchWithParams: (requestQueryParams: SubjectivitySearchRequestQuery) => {
    const { quoteId, ...params } = requestQueryParams;
    return [...subjectivityQueryKeys.search(quoteId), params] as const;
  },
};
